// extracted by mini-css-extract-plugin
module.exports = {"subtitleConfiguracao":"styles_subtitleConfiguracao__cQXJy","addLojasWrapper":"styles_addLojasWrapper__G3XrC","table":"styles_table__21yL_"};